module.exports = __webpack_public_path__ + "img/iPhone-crypto.bf7b292b.webp";